import { Component, OnInit, Output, EventEmitter, Input, ChangeDetectorRef } from '@angular/core'
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core'
import { QuoteCartService } from '../../../quote/quote-services/quote-cart.service'
import { QuoteCartFacade } from '../store/mini-quote-cart.facade';
import { Observable, of } from 'rxjs'
import { tap } from 'rxjs/operators'
import { AuthService, User } from '@spartacus/core'
import { switchMap } from 'rxjs/operators'
import { Router, NavigationEnd } from '@angular/router'
import { timeStamp } from 'console'

import {
  Ecommerce,
  EcommerceItem,
  GTMDataLayer,
  GTMCartType
} from '../../../../shared/models/googleTagManager.model';
import {
  ItemListTypeEnum,
  GtmEvents,
  StoreTypeEnum,
} from '../../../../shared/enums/gtm.enum';
import { GoogleTagManagerService } from '../../../../shared/services/gtm.service';

@Component({
  selector: 'vs-mini-quote-cart-details',
  standalone: false,
  templateUrl: './mini-quote-cart-details.component.html',
  styleUrl: './mini-quote-cart-details.component.scss',
})
export class MiniQuoteCartDetailsComponent implements OnInit {
  cart: any;
  prodname: any[] = [];
  quoteCart$: Observable<any>;
  @Output() miniQuoteCartReload = new EventEmitter<boolean>();
  @Output() closeMiniQuoteCartDetails = new EventEmitter<boolean>();

  constructor(
    private router: Router,
    private globalMessageService: GlobalMessageService,
    private quoteCartService: QuoteCartService,
    private cRef: ChangeDetectorRef,
    private gtmService: GoogleTagManagerService,
    private quoteCartFacade: QuoteCartFacade,
  ) {
  }

  ngOnInit(): void {
    this.quoteCart$ = this.quoteCartFacade.getCartData().pipe(
      tap((quoteCartData) => {
        this.cart = quoteCartData;
        this.prodname = quoteCartData?.entries || [];
        this.cRef.detectChanges();
      })
    );
    this.quoteCart$.subscribe();
  }

  closeMiniCart(event) {
    this.router.navigate(['quote/cart']);
    this.closeMiniQuoteCartDetails.emit(false);

    const viewcartItemsData: any[] = [];
    let totalValue = 0;
    this.prodname.forEach((itemEl, index) => {
      viewcartItemsData.push({
        item_id: itemEl?.product?.code,
        item_name: itemEl?.product?.name,
        index: index,
        item_list_id: ItemListTypeEnum.Cart,
        item_list_name: ItemListTypeEnum.Cart,
        price: itemEl?.totalPrice?.value,
        quantity: itemEl?.quantity,
      });
      totalValue += itemEl?.totalPrice?.value * itemEl?.quantity;
    });
    const viewCartDataLayer: GTMDataLayer = {
      event: GtmEvents.ViewCart,
      ecommerce: {
        currency: this.prodname[0]?.netPrice.currencyIso,
        value: totalValue,
        items: viewcartItemsData,
      },
      commerceType: GTMCartType.QUOTE_CART,
      cart_id: this.cart?.code
    };
    this.gtmService.sendEvent(viewCartDataLayer);
    this.cRef.detectChanges();
  }

  setQuoteProductDetailsGTM(product){
    if (product !== null && product !== undefined) {
      const viewItemDataLayer: GTMDataLayer = {
        event: GtmEvents.ViewItem,
        ecommerce: {
        currency: product?.netPrice?.currencyIso || '',
        value: product?.netPrice?.value || '',
        items: [
          {
            item_id: product?.code,
            item_name: product?.name,
            index: 0,
            item_category: product?.categories[0]?.name || '',
            item_category2: product?.categories[1]?.name || '',
            item_category3: product?.categories[2]?.name || '',
            item_category4: product?.categories[3]?.name || '',
            item_category5: product?.categories[4]?.name || '',
            item_list_id: ItemListTypeEnum.ProductDetail,
            item_list_name: ItemListTypeEnum.ProductDetail,
            price: product?.netPrice?.value
          },
        ],
        },
      };
      
      if (
        product &&
        product?.estShipData &&
        product?.estShipData[0]?.stockQty
      ) {
        viewItemDataLayer.ecommerce.items[0].quantity = Number(
        product?.estShipData[0]?.stockQty
        );
      }

      this.gtmService.sendEvent(viewItemDataLayer);
    }
  }
}
